<template>
  <div v-if="showTip" class="dsf-project-nationaldata-browser-tip-container">
    <div class="browser-tip-content">
      <div class="browser-tip-message">
        <i class="el-icon-warning"></i>
        <span v-if="!$root._isEn">为了获得更好的用户体验，请使用火狐、谷歌、360浏览器极速模式或IE9及以上版本的浏览器。</span>
        <span v-else>For the best possible user experience, we recommend IE9 or above, Chrome and Firefox.</span>
      </div>
      <div class="browser-tip-close" @click="closeTip">
        <i class="el-icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserTip',
  data() {
    return {
      showTip: false
    }
  },
  mounted() {
    this.checkBrowserTipStatus()
  },
  methods: {
    checkBrowserTipStatus() {
      // 检查sessionStorage中是否已关闭提示
      const hasClosed = sessionStorage.getItem('browserTipClosed')
      if (!hasClosed) {
        this.showTip = true
      }
    },
    closeTip() {
      // 用户点击关闭按钮，本次会话不再显示
      sessionStorage.setItem('browserTipClosed', 'true')
      this.showTip = false
    }
  }
}
</script>

